<template>
  <div class="container-xxl demand-letter-container mt-5">
    <div
      class="spinner-border"
      style="width: 15rem; height: 15rem"
      role="status"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoadingSpinner',
});
</script>
